import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { getWhatsAppLink } from '../../utils/whatsappLink';
const Footer = () => {
  const {
    t
  } = useLanguage();
  const whatsappLink = getWhatsAppLink('Hola Pedro, vi tu página web y quiero más información.');
  return <footer className="bg-dark text-white py-8 px-4" data-id="element-25">
      <div className="container mx-auto" data-id="element-26">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-27">
          <div data-id="element-28">
            <h3 className="font-heading font-semibold text-xl mb-2" data-id="element-29">
              {t.footer.title}
            </h3>
            <p className="text-gray-400" data-id="element-30">{t.footer.role}</p>
            <div className="flex items-center mt-3 text-gray-300" data-id="element-31">
              <MapPinIcon className="w-4 h-4 mr-2 text-primary flex-shrink-0" data-id="element-32" />
              <address className="not-italic text-sm" data-id="element-33">
                21400 NW 2nd Ave, Miami Gardens, FL 33169
              </address>
            </div>
          </div>
          <div className="flex flex-col items-center md:items-end" data-id="element-34">
            <a href={whatsappLink} className="text-white hover:text-primary transition-colors mb-2" target="_blank" rel="noopener noreferrer" data-id="element-35">
              WhatsApp: (857) 271-5381
            </a>
            <p className="text-gray-400 text-sm" data-id="element-36">
              © {new Date().getFullYear()} Pedro de la Cruz — Fleet Manager.{' '}
              {t.footer.rights}
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;